import { MedicineDetails } from '@dreryk/drerykweb-medicine-api';

export type MedicineAvailabilitySeverity = 'positive' | 'negative' | 'informative' | 'warning';

enum MedicineAvailabilityStatus {
   AVAILABLE_ON_THE_MARKET = '1',
   NOT_AVAILABLE_ON_THE_MARKET = '2',
   AVAILABILITY_LIMITED = '3',
   AVAILABILITY_PENDING_VERIFICATION = '4',
   SHORTENING_IN_TRADING_PERMANENTLY_AVAILABLE = '5',
   SHORTENING_IN_TRADING_PERMANENTLY_NOT_AVAILABLE = '6',
   TEMPORARY_HOLD_ON_THE_MARKET = '7',
   THREATENED_BY_LACK_OF_AVAILABILITY = '8',
   DRUG_REGULATION = '9',
   DURING_DATA_VALIDATION = '10',
}

export const mapMarketStatusSymbolToAvailabilitySeverity = (
   status: MedicineDetails['marketStatusSymbol']
): MedicineAvailabilitySeverity => {
   switch (status) {
      case MedicineAvailabilityStatus.AVAILABLE_ON_THE_MARKET:
         return 'positive';
      case MedicineAvailabilityStatus.DURING_DATA_VALIDATION:
      case MedicineAvailabilityStatus.AVAILABILITY_PENDING_VERIFICATION:
      case MedicineAvailabilityStatus.DRUG_REGULATION:
         return 'informative';
      case MedicineAvailabilityStatus.AVAILABILITY_LIMITED:
      case MedicineAvailabilityStatus.SHORTENING_IN_TRADING_PERMANENTLY_AVAILABLE:
      case MedicineAvailabilityStatus.THREATENED_BY_LACK_OF_AVAILABILITY:
         return 'warning';
      case MedicineAvailabilityStatus.NOT_AVAILABLE_ON_THE_MARKET:
      case MedicineAvailabilityStatus.SHORTENING_IN_TRADING_PERMANENTLY_NOT_AVAILABLE:
      case MedicineAvailabilityStatus.TEMPORARY_HOLD_ON_THE_MARKET:
         return 'negative';
      default:
         throw new Error(`Unsupported medicine availability status: ${status}`);
   }
};
